
































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapMutations } from 'vuex';
import axios from 'axios';

@Component({
    methods: {
        ...mapMutations('layout', ['changeTitle']),
    },
})
export default class CustomerInvoice extends Vue {
    treeObj: { id: string; name: string }[] = [];
    tree: string[] = [];
    years: string = '';
    snackbarError: boolean = false;
    loadingFile: string = '';

    getCardColor(i: number) {
        return '#00AAB8';
    }

    get items() {
        let facturas: {
            name: string;
            type: string;
            uriFormat: string;
            color: string | undefined;
        }[] = [];
        var d = new Date();
        for (var i = 1; i < 13; i++) {
            facturas.push({
                name:
                    this.getMonthName(
                        ((d.getMonth() + 1).toString().length == 1 ? '0' : '') + (d.getMonth() + 1),
                    ) +
                    ' ' +
                    d.getFullYear(),
                type: 'F',
                uriFormat:
                    d.getFullYear() +
                    '-' +
                    ((d.getMonth() + 1).toString().length == 1 ? '0' : '') +
                    (d.getMonth() + 1),
                color: this.getCardColor(i),
            });
            d.setMonth(d.getMonth() - 1);
        }
        return facturas;
    }

    getMonthName(monthNumber: string) {
        switch (monthNumber) {
            case '01':
                return 'Enero';
            case '02':
                return 'Febrero';
            case '03':
                return 'Marzo';
            case '04':
                return 'Abril';
            case '05':
                return 'Mayo';
            case '06':
                return 'Junio';
            case '07':
                return 'Julio';
            case '08':
                return 'Agosto';
            case '09':
                return 'Septiembre';
            case '10':
                return 'Octubre';
            case '11':
                return 'Noviembre';
            case '12':
                return 'Diciembre';
        }
    }

    mounted() {
        //@ts-ignore
        this.changeTitle({
            title: 'FACTURAS DE LOS ÚLTIMOS 12 MESES',
            route: ['FACTURACIÓN'],
        });
        let ruleDate: Date = new Date();
        this.years = ruleDate.getFullYear() + '-' + (ruleDate.getFullYear() - 1);
    }

    displayFile(res, newWindow) {
        const file = new Blob([res.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        newWindow.location = fileURL;
        newWindow.focus();
    }

    async openFile(uriFormat: string) {
        this.snackbarError = false;
        const company: any = localStorage.getItem('company');
        let newWindow: any = window.self;
        // setTimeout(function() {
        //   newWindow = window.open('');
        // }, 2000);
        this.loadingFile = uriFormat;
        this.$store
            .dispatch('getBill', {
                customerid: JSON.parse(company).id,
                date: uriFormat,
            })
            .then(res => {
                this.loadingFile = '';
                this.displayFile(res, newWindow);
            })
            .catch(e => {
                this.loadingFile = '';
                this.snackbarError = true;
                newWindow.close();
            });
    }
}
